export function createFetchWithClerk({ getBaseUrl, }) {
    return async (getToken, path, init = {}) => {
        const jwt = await getToken();
        if (!jwt) {
            throw new Error("clerk_session_missing");
        }
        const base = getBaseUrl();
        const url = base ? `${base}${path}` : path;
        const headers = new Headers(init.headers);
        headers.set("Authorization", `Bearer ${jwt}`);
        return fetch(url, { ...init, headers });
    };
}
/**
 * Carries the parsed body from a non-OK `/api/v1/me` response so the
 * per-reason `message` and `reason` fields the API ships (post-auth
 * diagnostics PR #259) reach the UI instead of getting stripped down
 * to `me_http_403`.
 */
export class FetchMeHttpError extends Error {
    status;
    body;
    constructor(status, body) {
        super(`me_http_${status}`);
        this.status = status;
        this.body = body;
        this.name = "FetchMeHttpError";
    }
}
export function createFetchMe(fetcher) {
    return async (getToken) => {
        const res = await fetcher(getToken, "/api/v1/me");
        if (!res.ok) {
            let body = null;
            try {
                body = (await res.json());
            }
            catch {
                body = null;
            }
            throw new FetchMeHttpError(res.status, body);
        }
        return (await res.json());
    };
}
/** Maps `fetchMe` / network failures to user-facing copy. */
export function formatMeFetchError(err) {
    if (!(err instanceof Error)) {
        return "Could not load your profile from the API.";
    }
    if (err.message === "clerk_session_missing") {
        return "Sign in again — your session token was missing.";
    }
    if (err instanceof FetchMeHttpError) {
        const body = err.body;
        if (err.status === 401) {
            return body?.message ?? "The API rejected your sign-in token (401). Sign in again.";
        }
        if (err.status === 403) {
            return body?.message ?? "The API could not authorize this account (403).";
        }
        if (body?.message)
            return `${body.message} (HTTP ${err.status})`;
        return `Profile request failed (HTTP ${err.status}).`;
    }
    if (err.message.includes("Failed to fetch") || err.name === "TypeError") {
        return "Could not reach the API (network error). Check your connection.";
    }
    return err.message || "Could not load your profile from the API.";
}
//# sourceMappingURL=fetch-with-clerk.js.map